import AuthMiddleware from "@/middleware/auth"

const AllRules = () =>
  import(
     "@/components/billingRuleBook/AllRules"
  )
  const AddRules = () =>
    import(
     "@/components/billingRuleBook/AddRules"
    )  
const RuleBookRouter = [
  {
    path: "/billing-rules/coding-rules",
    name: "AllCodingRules",
    component: AllRules,
    beforeEnter: AuthMiddleware.user,
    meta: {
      title: "RULE BOOK",
    },
  },
 {
    path: "/billing-rules/claim-processing",
    name: "AllClaim",
    component: AllRules,
    beforeEnter: AuthMiddleware.user,
    meta: {
      title: "RULE BOOK",
    },
  },
   {
    path: "/billing-rules/ar-rules",
    name: "AllARRules",
    component: AllRules,
    beforeEnter: AuthMiddleware.user,
    meta: {
      title: "RULE BOOK",
    },
  },
   {
    path: "/billing-rules/payment-posting",
    name: "PaymentRules",
    component: AllRules,
    beforeEnter: AuthMiddleware.user,
    meta: {
      title: "RULE BOOK",
    },
  },
    {
    path: "/billing-rules/patient-statement",
    name: "PateintRules",
    component: AllRules,
    beforeEnter: AuthMiddleware.user,
    meta: {
      title: "RULE BOOK",
    },
  },
  {
    path: "/add-rules",
    name: "AddRules",
    component: AddRules,
    beforeEnter: AuthMiddleware.user,
    meta: {
      title: "RULE BOOK",
    },
  },
  {
    path: "/update-rules/:rule_id",
    name: "UpdatedRules",
    component: AddRules,
    beforeEnter: AuthMiddleware.user,
    meta: {
      title: "RULE BOOK",
    },
  }
]

export { RuleBookRouter }
